import React from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';

import routes from './routes';

const renderRoutes = () => (
  routes.map((routeData) => (
    <Route
      key={routeData.path}
      exact={routeData.exact}
      path={routeData.path}
      component={routeData.component}
    />
  ))
);

const Base = () => (
  <Router>
      <Switch>
        {renderRoutes()}
      </Switch>
  </Router>
);

export default Base;


// WEBPACK FOOTER //
// ./src/routes/Base.jsx